import axios from "axios";
import * as CookieService from "../Cookie/CookieService";

const path = '/api/v1/classroom/online';

export function getVideoList() {
    return axios.get(path + '', CookieService.setHeaders());
}

export function getVideoListByClassroom(classroomName) {
    return axios.get(path + '?classroomName=' + classroomName, CookieService.setHeaders());
}

export function updateVideoListByClassroom(classroomName, videoPath) {
    let video = {videoName: videoPath};
    return axios.post(path + '?classroomName=' + classroomName, video, CookieService.setHeaders());
}


// WEBPACK FOOTER //
// ./src/services/Online/OnlineService.js